import { api } from "@api/api";
import { TiledeskStatus } from "@modules/tiledesk/types";

export async function disableTiledeskService(
  agreementId: string
): Promise<TiledeskStatus> {
  const { data } = await api.post<TiledeskStatus>(
    `v1/tiledesk/agreements/${agreementId}/disable/`
  );
  return data;
}
